/* NuBest v2.1 journey pages (policy template, Our Story, Subscribe & Save, HSA/FSA).
   Vanilla JS, no dependencies, loaded with `defer` by the sections that need it.
   1. --hdr: the sticky v2.1 header height, used by the sticky TOC and heading scroll offsets.
   2. Policy TOC: built from the H2/H3 headings of .nbj-doc, scroll-spy, mobile "On this page" panel.
   3. Tabs (HSA/FSA one-time / subscription): role=tab buttons switch the panels, arrow keys move between tabs. */
(function () {
  'use strict';
  var roots = document.querySelectorAll('.nbj-root');
  if (!roots.length) return;

  /* ---------- 1. header height ---------- */
  var header = document.getElementById('shopify-section-nb-header') || document.querySelector('.t4s-section-header');
  function setHdr() {
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    for (var i = 0; i < roots.length; i++) roots[i].style.setProperty('--hdr', (h || 66) + 'px');
    return h;
  }
  setHdr();
  window.addEventListener('resize', setHdr);
  if (window.ResizeObserver && header) new ResizeObserver(setHdr).observe(header);
  /* The header hides on scroll down on phones and tablets (.nbh-hidden): mirror that on the roots so the sticky TOC can close the gap. */
  function syncHidden() {
    var off = !!(header && header.classList.contains('nbh-hidden'));
    for (var i = 0; i < roots.length; i++) roots[i].classList.toggle('nbj-hdr-off', off);
  }
  syncHidden();
  if (window.MutationObserver && header) new MutationObserver(syncHidden).observe(header, { attributes: true, attributeFilter: ['class'] });

  /* ---------- 2. table of contents ---------- */
  var toc = document.querySelector('[data-nbj-toc]');
  var doc = document.querySelector('.nbj-doc');
  if (toc && doc) {
    var depth = parseInt(toc.getAttribute('data-nbj-toc-depth') || '2', 10);
    var list = toc.querySelector('[data-nbj-toc-list]');
    var btn = toc.querySelector('[data-nbj-toc-btn]');
    var cur = toc.querySelector('[data-nbj-toc-cur]');
    // Pages that show their admin content (e.g. the app-managed privacy request page): give its H2/H3 the TOC class and an id.
    Array.prototype.forEach.call(doc.querySelectorAll('.t4s-rte h2, .t4s-rte h3'), function (h, i) {
      h.classList.add('nbj-h');
      if (!h.id) h.id = (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48) || 'section-' + (i + 1);
    });
    var sel = depth >= 3 ? 'h2.nbj-h, h3.nbj-h' : 'h2.nbj-h';
    var heads = Array.prototype.slice.call(doc.querySelectorAll(sel)).filter(function (h) { return h.id; });
    var links = [];
    heads.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'nbj-toc__a' + (h.tagName === 'H3' ? ' is-sub' : '');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        close();
        setActive(h.id);
        // On phones the header hides when the page scrolls down and returns when it scrolls up, so the heading needs
        // a different offset depending on where it is: below us (header hidden) or above us (header back).
        if (btn && btn.offsetParent !== null) {
          var below = h.getBoundingClientRect().top > 0;
          h.style.scrollMarginTop = (below ? 0 : header ? header.getBoundingClientRect().height : 0) + btn.getBoundingClientRect().height + 20 + 'px';
          setTimeout(function () { h.style.scrollMarginTop = ''; }, 1600);
        }
        h.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + h.id);
      });
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });
    function prefersReduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function setActive(id) {
      links.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        a.classList.toggle('is-on', on);
        if (on) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
        if (on && cur) cur.textContent = a.textContent;
      });
    }
    function offset() {
      var hh = header && !header.classList.contains('nbh-hidden') ? header.getBoundingClientRect().height : 0;
      var bh = btn && btn.offsetParent !== null ? btn.getBoundingClientRect().height : 0;
      return hh + bh + 40;
    }
    var ticking = false;
    function spy() {
      ticking = false;
      if (!heads.length) return;
      var off = offset();
      var id = heads[0].id;
      for (var i = 0; i < heads.length; i++) {
        if (heads[i].getBoundingClientRect().top <= off) id = heads[i].id;
      }
      setActive(id);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(spy); }
    }, { passive: true });
    spy();

    /* mobile panel */
    function open() { toc.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    function close() { toc.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    if (btn) {
      btn.addEventListener('click', function () { toc.classList.contains('is-open') ? close() : open(); });
      document.addEventListener('click', function (e) { if (!toc.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
  }

  /* ---------- 3. tabs ---------- */
  var tablists = document.querySelectorAll('[data-nbj-tabs]');
  Array.prototype.forEach.call(tablists, function (tl) {
    var tabs = Array.prototype.slice.call(tl.querySelectorAll('[role="tab"]'));
    var panels = document.querySelector('[data-nbj-panels="' + tl.getAttribute('data-nbj-tabs') + '"]');
    function pick(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      if (panels) {
        panels.className = panels.className.replace(/\bis-[a-z0-9_-]+/g, '').trim() + ' is-' + tab.getAttribute('data-nbj-tab');
        Array.prototype.forEach.call(panels.querySelectorAll('[role="tabpanel"]'), function (p) {
          p.hidden = p.getAttribute('aria-labelledby') !== tab.id;
        });
      }
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t); });
      t.addEventListener('keydown', function (e) {
        var j = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : -1;
        if (j < 0 && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        pick(tabs[(j + tabs.length) % tabs.length], true);
      });
    });
    var initial = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    if (initial) pick(initial);
  });

  /* ---------- deep link into a collapsed section (e.g. footer "Subscription Terms" -> #terms) ---------- */
  function openHash() {
    var id = decodeURIComponent((location.hash || '').slice(1));
    if (!id) return;
    var el = document.getElementById(id);
    var det = el && (el.tagName === 'DETAILS' ? el : el.closest && el.closest('details'));
    if (det && det.closest('.nbj-root') && !det.open) {
      det.open = true;
      setTimeout(function () {
        var hdr = parseInt(getComputedStyle(det.closest('.nbj-root')).getPropertyValue('--hdr'), 10) || 0;
        window.scrollTo(0, el.getBoundingClientRect().top + window.pageYOffset - hdr - 16);
      }, 0);
    }
  }
  openHash();
  window.addEventListener('hashchange', openHash);
})();
